import React, { FC } from 'react';
import { Box, ResponsiveValue } from '@chakra-ui/react';

const ControlButton: FC<{
    onClick: () => void;
    ariaLabel: string;
    bg?: string;
    w?: ResponsiveValue<string>;
    h?: ResponsiveValue<string>;
    children: React.ReactNode;
}> = ({ onClick, ariaLabel, bg = 'transparent', w = 'auto', h = 'auto', children }) => (
    <Box
        as="button"
        onClick={onClick}
        aria-label={ariaLabel}
        p="8px"
        rounded="4px"
        bg={bg}
        border="none"
        cursor="pointer"
        color="white"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        w={w}
        h={h}
        // `color` is repeated here on purpose. The client gallery's global stylesheet styles
        // bare `button` elements like anchors, and its `button:hover` rule (specificity 0-1-1)
        // outranks the generated class this component's `color` prop produces (0-1-0) — which
        // turned the icon brand-blue on hover in client galleries but not in studio. Restating
        // it under `_hover` matches that specificity, and the emotion styles land later.
        _hover={{
            bg: bg === 'transparent' ? 'blackAlpha.600' : 'blackAlpha.800',
            color: 'white'
        }}
    >
        {children}
    </Box>
);

export default ControlButton;
